import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { ScrollToTop } from "@/components/ScrollToTop";
import Index from "./pages/Index";

const NotFound = lazy(() => import("./pages/NotFound"));
const MastermindGroups = lazy(() => import("./pages/MastermindGroups"));
const MastermindSchedule = lazy(() => import("./pages/MastermindSchedule"));
const Coaching = lazy(() => import("./pages/Coaching"));
const OrganizationalLeadership = lazy(() => import("./pages/OrganizationalLeadership"));
const MaxwellDisc = lazy(() => import("./pages/MaxwellDisc"));
const CpaFirms = lazy(() => import("./pages/CpaFirms"));
const WorkshopsLunchLearns = lazy(() => import("./pages/WorkshopsLunchLearns"));
const EntrepreneurSales = lazy(() => import("./pages/EntrepreneurSales"));
const CollegeCareer = lazy(() => import("./pages/CollegeCareer"));
const Auth = lazy(() => import("./pages/Auth"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      {/* The router lives in entry-client / entry-server so the same App tree
          renders under BrowserRouter in the browser and StaticRouter during
          the build-time prerender. */}
      <>
        <ScrollToTop />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/programs/mastermind-groups" element={<MastermindGroups />} />
            <Route path="/programs/mastermind-groups/schedule" element={<MastermindSchedule />} />
            <Route path="/programs/coaching" element={<Coaching />} />
            <Route path="/programs/organizational-leadership" element={<OrganizationalLeadership />} />
            <Route path="/programs/maxwell-disc" element={<MaxwellDisc />} />
            <Route path="/programs/cpa-firms" element={<CpaFirms />} />
            <Route path="/programs/workshops-lunch-learns" element={<WorkshopsLunchLearns />} />
            <Route path="/programs/entrepreneur-sales" element={<EntrepreneurSales />} />
            <Route path="/programs/college-career" element={<CollegeCareer />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
